/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.QuizAttemptService
 */
import * as References from './QuizAttemptService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.QuizAttemptService#start
 */
export const START_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_QuizAttemptService_start';
export const START_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: START_MUTATION_FIELD_NAME,
  args: ['contentId', 'language', 'academyLanguage', 'trackId', 'playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.startRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.QuizAttemptService#finish
 */
export const FINISH_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_QuizAttemptService_finish';
export const FINISH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: FINISH_MUTATION_FIELD_NAME,
  args: ['attemptId', 'trackId', 'playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.finishRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.QuizAttemptService#checkQuestion
 */
export const CHECK_QUESTION_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_QuizAttemptService_checkQuestion';
export const CHECK_QUESTION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CHECK_QUESTION_MUTATION_FIELD_NAME,
  args: ['attemptId', 'questionSubmission'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.checkQuestionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});